<template>
 <div id="side-Navigation-view">
   <ul>
      <router-link tag="li" to="statement.htm" class="sideli">披露声明</router-link>
      <li class="menu-list">
        <ol  class="list-title">
          <li>
            <i></i><span>关于普惠</span>
          </li>
        </ol>
        <ol class="second-list">
          <router-link tag="li" to="/companyMessage/aboutour.htm" class="sideli">关于我们</router-link>
          <router-link tag="li" to="/companyMessage/visionAndAction.htm" class="sideli">愿景&行动</router-link>
          <router-link tag="li" to="/companyMessage/pattern.htm" class="sideli">模式介绍</router-link>
          <router-link tag="li" to="/companyMessage/managementTeam.htm" class="sideli">团队介绍</router-link>
          <router-link tag="li" to="/companyMessage/organizational.htm" class="sideli">组织架构</router-link>
          <router-link tag="li" to="/companyMessage/platform.htm" class="sideli">平台资质</router-link>
          <router-link tag="li" to="/companyMessage/contactUs.htm" class="sideli">联系我们</router-link>
        </ol>
      </li>
      <li class="menu-list">
        <ol class="list-title">
          <li>
            <i></i><span>信息披露</span>
          </li>
        </ol>
        <ol class="second-list">
          <router-link tag="li" to="/companyMessage/businessInformation.htm" class="sideli">工商信息</router-link>
          <router-link tag="li" to="/companyMessage/platformInformation.htm" class="sideli">平台信息</router-link>
          <router-link tag="li" to="/companyMessage/shareholderInformation.htm" class="sideli">股东信息</router-link>
          <router-link tag="li" to="/companyMessage/bigMatters.htm" class="sideli">重大事项</router-link>
          <router-link v-show="info.id" tag="li" to="/companyMessage/recordSchedule.htm" class="sideli">备案进度</router-link>
          <router-link v-show="info.id" tag="li" to="/companyMessage/chargeStandard.htm" class="sideli">收费标准</router-link>
        </ol>
      </li>
      <li class="menu-list">
        <ol  class="list-title">
          <li>
            <i></i><span>协议范本</span>
          </li>
        </ol>
        <ol class="second-list">
          <router-link tag="li" to="/companyMessage/riskHints.htm" class="sideli">风险提示</router-link>
          <!-- //注释绑卡和充值协议协议 --gherkin 2023年5月6日15:09:29 -->
          <!-- <router-link tag="li" to="/companyMessage/cardpovison.htm" class="sideli">绑卡协议</router-link> -->
          <!-- <router-link tag="li" to="/companyMessage/rechargepovison.htm" class="sideli">充值协议</router-link> -->
          <router-link v-show="info.id" tag="li" to="/companyMessage/loanAgreement.htm" class="sideli">出借协议</router-link>
          <router-link v-show="info.id" tag="li" to="/companyMessage/transfer.htm" class="sideli">转让协议</router-link>
          <router-link tag="li" to="/companyMessage/privacyClause.htm" class="sideli">隐私条款</router-link>
          <router-link tag="li" to="/companyMessage/riskGrade.htm" class="sideli">风险等级</router-link>
        </ol>
      </li>
   </ul>
 </div>
</template>

<script>
export default {
  data () {
    return {
      info: this.loginUserInfo
    }
  },
  components: {

  }
}
</script>

<style lang="less">
#side-Navigation-view{
  width: 200px;
  float: left;
  margin-bottom: 20px;
  ul{
    width: 100%;
    background: #fff;
    overflow: hidden;
    padding-bottom: 10px;
    li{
      width: 200px;
    }
    >li:first-child{
      margin-top: 20px;
      padding-left: 60px;
      line-height: 44px;
      width: 200px;
      height: 44px;
      font-size: 14px;
      font-weight: 500;
      color: #323232;
      cursor: pointer;
    }
    .router-active {
      background: #fafafa;
      color: #e6382c;
      position: relative;
    }
    .router-active:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 44px;
      background: #e6382c;
    }
    .menu-list{
      position: relative;
      .list-title{
        li{
          padding: 20px 0 15px 0;
          i{
            display: inline-block;
            width: 6px;
            height: 6px;
            background: #666;
            position: absolute;
            left: 40px;
            top:28px;
          }
          span{
            font-size: 14px;
            color: #999999;
            margin-left:60px;
          }
        }
      }
      .second-list{
        margin-bottom: 10px;
        li {
          // text-align: center;
          padding-left: 60px;
          line-height: 44px;
          width: 200px;
          height: 44px;
          font-size: 14px;
          font-weight: 500;
          color: #323232;
          cursor: pointer;
        }
      }
    }
    .sideli{
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sideNavigation.vue